import { useTranslation } from 'react-i18next';
import { Box, Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CurrentSubscription from './currentSubscription';
import NewSubscription from './newSubscription';
import { getCurrencyDetails } from '../../../utils/common';
import { YEARLY } from '../../../constants/upgradeJourney.constant';
import LocaleKeys from '../../../locales/keys';

const useStyles = makeStyles((theme) => ({
  reviewOrderDetailsImage: {
    [theme.breakpoints.down('lg')]: {
      marginBottom: '20px',
    },
  },
  subscriptionQuoteItemContainer: {
    marginBottom: '20px',
  },
  divider: {
    border: `1px  solid ${theme.palette.custom.divider}`,
    margin: '20px 0px',
  },
  listItemNode: {
    flex: '1 1 50%',
    letterSpacing: '.2px',
    fontSize: '17px',
    lineHeight: '1.5',
    [theme.breakpoints.between('xs', 'md')]: {
      margin: 0,
      width: '100%',
    },
  },
  listItemContainer: {
    padding: '0px 0 0 0',
    alignItems: 'flex-start',
    [theme.breakpoints.between('xs', 'md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  discountAmount: {
    color: 'gray',
  },
}));

const OrderDetailsUpgradePricingPlan = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    upgradePlanState,
    calculateOrderQuoteResponse,
    translatedOrderItems,
  } = props;

  const currentThumbnailUrl =
    upgradePlanState?.activeSubscriptionDetails?.Items?.[0]?.Product
      ?.ThumbnailUrl;
  const currentCycleEnd = new Date().toISOString();
  const upgradeThumbnailUrl = translatedOrderItems?.[0]?.thumbnailUrl;
  const subscriptionStartDate = new Date().toISOString();
  const newSubscriptionAmount = translatedOrderItems?.[0]?.totalAmountDisplay;
  const newGrossAmount = translatedOrderItems?.[0]?.grossAmount;
  const switchTotalAmountDisplayTemplate =
    translatedOrderItems?.[0]?.switchTotalAmountDisplayTemplate;
  const renewalDate =
    calculateOrderQuoteResponse?.orderQuote?.SubscriptionQuotes?.[0]
      ?.CycleStart;
  const getBillCycleText =
    upgradePlanState?.billCycle?.toLowerCase() === YEARLY
      ? t(LocaleKeys.subscriptionInfo.subscriptions.year)
      : t(LocaleKeys.subscriptionInfo.subscriptions.month);
  const getRefundAmountCurrency =
    upgradePlanState?.activeSubscriptionDetails?.Items?.[0]?.PricingPlan
      ?.Currency || calculateOrderQuoteResponse?.orderQuote?.Quote?.Currency;
  const refundAmount = getCurrencyDetails(
    calculateOrderQuoteResponse?.orderQuote?.TotalRemainingAmount,
    getRefundAmountCurrency,
  );
  return (
    <Box className="ascendon-order-summary">
      <Box className="panel panel-default order-summary-container">
        <Box className="panel-body">
          {/* Cart Items */}
          <Grid className="order-item-details" container>
            <Grid item container>
              <CurrentSubscription
                classes={classes}
                thumbnailUrl={currentThumbnailUrl}
                currentCycleEnd={currentCycleEnd}
                refundAmount={refundAmount}
              />
              <Divider className={classes.divider} />
              <NewSubscription
                classes={classes}
                thumbnailUrl={upgradeThumbnailUrl}
                subscriptionStartDate={subscriptionStartDate}
                newSubscriptionAmount={newSubscriptionAmount}
                newGrossAmount={newGrossAmount}
                hasDiscount={switchTotalAmountDisplayTemplate}
                renewalDate={renewalDate}
                billCycleText={getBillCycleText}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderDetailsUpgradePricingPlan;
